// paths are relative to node_modules/
// Angular 2
import '@angular/platform-browser';
import '@angular/platform-browser-dynamic';
import '@angular/core';
import '@angular/common';
import '@angular/http';
import '@angular/router';

// Other vendors for example jQuery, Lodash or Bootstrap
import './style/font-awesome/font-awesome.scss';
import 'ngx-bootstrap/datepicker/bs-datepicker.css';
import 'jquery';




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/vendor.ts